import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { NewReleases } from '@mui/icons-material';

export const UrlError = () => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <NewReleases sx={{ color: (theme) => theme.palette.primary.main, fontSize: 30 }} />

      <Box sx={{ paddingTop: 1.5, paddingBottom: 8 }}>
        <Typography variant="body2" color="textSecondary">
          The request URL is invalid.
        </Typography>

        <Typography variant="body2" color="textSecondary">
          Please reach out to support team to investigate the issue.
        </Typography>
      </Box>

      <Link variant="body2" href="mailto:support@mycora.us" sx={{ lineHeight: 'inherit', fontWeight: 600 }}>
        Contact our support team
      </Link>
    </Box>
  );
};
